<template lang="pug"></template>

<script>
export default {
    name: 'BotaoSig',
    componentOptions: {
        title: 'SIG',
        actions: [
            [
                {
                    name: 'SIG',
                    iconClass: 'lyra-icon lyra-sig',
                    showView: false,
                    action: 'abrirSig',
                    route: 'SIG',
                    nameTranslationKey: 'mensagens.menuLateral.sig'
                }
            ]
        ]
    },

    methods: {
        abrirSig() {
            if (this.$route.name !== 'SIG') {
                this.$router.push({ name: 'SIG' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
